document.addEventListener("DOMContentLoaded", function() {
  // Scroll animations
  var elements = document.querySelectorAll(".animate-on-scroll");
  if (!elements.length) return;
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add("visible");
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  elements.forEach(function(el) { observer.observe(el); });

  // FAQ accordion
  document.querySelectorAll(".faq-question").forEach(function(btn) {
    btn.addEventListener("click", function() {
      var item = this.closest(".faq-item");
      var wasActive = item.classList.contains("active");
      document.querySelectorAll(".faq-item").forEach(function(i) { i.classList.remove("active"); });
      if (!wasActive) item.classList.add("active");
    });
  });

  // Cookie bar
  var cookieBar = document.querySelector(".cookie-bar");
  if (cookieBar && !localStorage.getItem("cookies_accepted")) {
    setTimeout(function() { cookieBar.classList.add("visible"); }, 2000);
  }
  var cookieBtn = document.querySelector(".cookie-bar__btn");
  if (cookieBtn) {
    cookieBtn.addEventListener("click", function() {
      localStorage.setItem("cookies_accepted", "true");
      cookieBar.classList.remove("visible");
    });
  }

  // Newsletter popup
  var popup = document.querySelector(".newsletter-popup");
  if (popup && !localStorage.getItem("newsletter_dismissed")) {
    setTimeout(function() { popup.classList.add("active"); }, 5000);
  }
  var popupClose = document.querySelector(".newsletter-popup__close");
  if (popupClose) {
    popupClose.addEventListener("click", function() {
      popup.classList.remove("active");
      localStorage.setItem("newsletter_dismissed", "true");
    });
  }

  // Cart drawer
  var cartBtn = document.querySelector(".cart-toggle");
  var cartDrawer = document.querySelector(".cart-drawer");
  var cartOverlay = document.querySelector(".cart-overlay");
  var cartClose = document.querySelector(".cart-drawer__close");
  if (cartBtn && cartDrawer) {
    cartBtn.addEventListener("click", function(e) {
      e.preventDefault();
      cartDrawer.classList.add("open");
      cartOverlay.classList.add("open");
    });
    if (cartClose) cartClose.addEventListener("click", function() {
      cartDrawer.classList.remove("open");
      cartOverlay.classList.remove("open");
    });
    if (cartOverlay) cartOverlay.addEventListener("click", function() {
      cartDrawer.classList.remove("open");
      cartOverlay.classList.remove("open");
    });
  }

  // Gallery thumbs — FIX FLOU
  document.querySelectorAll(".showcase-gallery__thumb").forEach(function(thumb) {
    thumb.addEventListener("click", function() {
      var thumbImg = this.querySelector("img");
      var main = this.closest(".showcase-gallery").querySelector(".showcase-gallery__main img");

      if (main && thumbImg) {
        // Récupère l'URL haute qualité depuis data-src ou reconstruit depuis srcset
        var fullSrc = thumbImg.getAttribute("data-full-src");

        if (!fullSrc) {
          // Remplace width=120 par width=800 dans l'URL Shopify
          fullSrc = thumbImg.src.replace(/width=\d+/, "width=800");
        }

        main.src = fullSrc;
      }

      this.closest(".showcase-gallery__thumbs")
        .querySelectorAll(".showcase-gallery__thumb")
        .forEach(function(t) { t.classList.remove("active"); });
      this.classList.add("active");
    });
  });

  // Mobile menu
  var hamburger = document.querySelector(".hamburger");
  var nav = document.querySelector(".header-nav");
  if (hamburger && nav) {
    hamburger.addEventListener("click", function() {
      nav.style.display = nav.style.display === "flex" ? "none" : "flex";
      nav.style.position = "absolute";
      nav.style.top = "100%";
      nav.style.left = "0";
      nav.style.right = "0";
      nav.style.background = "#fff";
      nav.style.flexDirection = "column";
      nav.style.padding = "20px";
      nav.style.boxShadow = "0 4px 20px rgba(0,0,0,0.08)";
    });
  }
});